import React, { useState, useReducer } from "react";
import type { ISRS, SrsName, SrsPair } from "../types";
import Card from "./Card";
import SrsSelector from "./SrsSelector";
import tableReducer, {
  updateRow,
  createInitialTableReducerState,
  createEmptyRow,
} from "../tableReducer";
import JointLabelsRow from "./JointLabelsRow";
import JointCoordsRow from "./JointCoordsRow";

import { makeSimpleId } from "../../../../utils";
import { style } from "typestyle";
import { vSpaced } from "../../../../cssUtils";

interface MatrixCalculatorTableProps {
  srs: ISRS,
}

export default function MatrixCalculatorTable({
  srs,
}: MatrixCalculatorTableProps) {
  const srsSet: SrsName[] = srs.assumedSrs
    ? ["assumed", "global", "wgs84"]
    : ["global", "wgs84"];

  const [srsPair, setSrsPair] = useState<SrsPair>([srsSet[0], srsSet[1]]);
  const [rows, dispatchRows] = useReducer(
    tableReducer,
    createInitialTableReducerState(2),
  );
  const blankRowId = makeSimpleId();

  return (
    <Card>
      <SrsSelector srsSet={srsSet} srsPair={srsPair} onChange={setSrsPair} />
      <div className={style(vSpaced(12))}>
        <JointLabelsRow />
        {[...Object.keys(rows), blankRowId].map(id => (
          <JointCoordsRow
            srsPair={srsPair}
            srs={srs}
            coords={rows[id] ? rows[id] : createEmptyRow()}
            onChange={coords => dispatchRows(updateRow(id, coords))}
            key={id}
          />
        ))}
      </div>
    </Card>
  );
}
